import { Box, Button, Grid } from "@mui/material";
import DriverPopup from "../../components/Fleet/DriverPopup/DriverPopup";
import "../../assets/styles/pages/Fleet/driverPage.css";
import ExcelUploadPopup from "../../components/Fleet/ExcelUploadPopup/ExcelUploadPopup";
import { useState } from "react";
import DriverTable from "../../components/Fleet/DriverTable/DriverTable";
import SettlementPayeePopup from "../../components/Fleet/SettlementPayeePopup/SettlementPayeePopup";

const DriverPage = () => {
  const [isExcelOpen, setIsExcelOpen] = useState(false);
  const [isSettlementPayeeOpen, setIsSettlementPayeeOpen] = useState(false);

  const openExcelUploadModal = () => {
    setIsExcelOpen(true);
  };

  const openSettlementPayeeModal = () => {
    setIsSettlementPayeeOpen(true);
  };

  return (
    <Box className="driver-page">
      <Grid container spacing={1} alignItems="center" justifyContent="center">
        <Grid
          item
          xs={12}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box
            sx={{
              flexWrap: { xs: "wrap", lg: "nowrap" },
              flex: 1,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid
              container
              spacing={1}
              justifyContent="center"
              sx={{ maxWidth: "800px" }}
            >
              <Grid item>
                <DriverPopup />
              </Grid>
              <Grid item>
                <SettlementPayeePopup />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  component="label"
                  onClick={openExcelUploadModal}
                >
                  Upload McLoad Drivers
                </Button>
                <ExcelUploadPopup
                  open={isExcelOpen}
                  onClose={() => setIsExcelOpen(false)}
                  fileType="driver"
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  component="label"
                  onClick={openSettlementPayeeModal}
                >
                  Upload Settlement Payees
                </Button>
                <ExcelUploadPopup
                  open={isSettlementPayeeOpen}
                  onClose={() => setIsSettlementPayeeOpen(false)}
                  fileType="settlementPayee"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <DriverTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DriverPage;
